import buildLocalizeFn from '../../../_lib/buildLocalizeFn/index'

var eraValues = {
  "abbreviated": [
    "قبل مسیح",
    "عیسوی",
  ],
  "narrow": [
    "قبل مسیح",
    "عیسوی",
  ],
  "wide": [
    "قبل مسیح",
    "عیسوی",
  ],
}

var quarterValues = {
  "abbreviated": [
    "پہلی سہ ماہی",
    "دوسری سہ ماہی",
    "تیسری سہ ماہی",
    "چوتهی سہ ماہی",
  ],
  "narrow": [
    "1",
    "2",
    "3",
    "4",
  ],
  "wide": [
    "پہلی سہ ماہی",
    "دوسری سہ ماہی",
    "تیسری سہ ماہی",
    "چوتهی سہ ماہی",
  ],
}

var formattingQuarterValues = quarterValues

var monthValues = {
  "abbreviated": [
    "جنوری",
    "فروری",
    "مارچ",
    "اپریل",
    "مئی",
    "جون",
    "جولائی",
    "اگست",
    "ستمبر",
    "اکتوبر",
    "نومبر",
    "دسمبر",
  ],
  "narrow": [
    "J",
    "F",
    "M",
    "A",
    "M",
    "J",
    "J",
    "A",
    "S",
    "O",
    "N",
    "D",
  ],
  "wide": [
    "جنوری",
    "فروری",
    "مارچ",
    "اپریل",
    "مئی",
    "جون",
    "جولائی",
    "اگست",
    "ستمبر",
    "اکتوبر",
    "نومبر",
    "دسمبر",
  ],
}

var formattingMonthValues = monthValues

var dayValues = {
  "abbreviated": [
    "اتوار",
    "پیر",
    "منگل",
    "بدھ",
    "جمعرات",
    "جمعہ",
    "ہفتہ",
  ],
  "narrow": [
    "S",
    "M",
    "T",
    "W",
    "T",
    "F",
    "S",
  ],
  "short": [
    "اتوار",
    "پیر",
    "منگل",
    "بدھ",
    "جمعرات",
    "جمعہ",
    "ہفتہ",
  ],
  "wide": [
    "اتوار",
    "پیر",
    "منگل",
    "بدھ",
    "جمعرات",
    "جمعہ",
    "ہفتہ",
  ],
}

var formattingDayValues = dayValues

var dayPeriodValues = {
  "abbreviated": {
    "afternoon": "دوپہر",
    "am": "AM",
    "evening": "شام",
    "midnight": "آدھی رات",
    "morning": "صبح",
    "night": "رات",
    "noon": undefined,
    "pm": "PM",
  },
  "narrow": {
    "afternoon": "دوپہر",
    "am": "AM",
    "evening": "شام",
    "midnight": "آدھی رات",
    "morning": "صبح",
    "night": "رات",
    "noon": undefined,
    "pm": "PM",
  },
  "wide": {
    "afternoon": "دوپہر",
    "am": "AM",
    "evening": "شام",
    "midnight": "آدھی رات",
    "morning": "صبح",
    "night": "رات",
    "noon": undefined,
    "pm": "PM",
  },
}

var formattingDayPeriodValues = {
  "abbreviated": {
    "afternoon": "دوپہر",
    "am": "AM",
    "evening": "شام",
    "midnight": "آدھی رات",
    "morning": "صبح",
    "night": "رات",
    "noon": undefined,
    "pm": "PM",
  },
  "narrow": {
    "afternoon": "دوپہر",
    "am": "a",
    "evening": "شام",
    "midnight": "آدھی رات",
    "morning": "صبح",
    "night": "رات",
    "noon": undefined,
    "pm": "p",
  },
  "wide": {
    "afternoon": "دوپہر میں",
    "am": "AM",
    "evening": "شام میں",
    "midnight": "آدھی رات",
    "morning": "صبح میں",
    "night": "رات میں",
    "noon": undefined,
    "pm": "PM",
  },
}

function ordinalNumber(dirtyNumber, _dirtyOptions) {
  return dirtyNumber
}

var localize = {
  ordinalNumber: ordinalNumber,

  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),

  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    formattingValues: formattingQuarterValues,
    argumentCallback: function(quarter) {
      return Number(quarter) - 1
    }
  }),

  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide',
    formattingValues: formattingMonthValues,
    defaultFormattingWidth: 'wide'
  }),

  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayValues,
    defaultFormattingWidth: 'wide'
  }),

  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
}

export default localize
